import './books/search-product';
import './department/select-department';
import './google/map/set_maps';
import './google/map/distribution-marker-maps';
import './google/map/search-place';
import './images/popup_on_click';
import './markdown-file/markdown-file-uploader';
import './master-image/search-master';
import './master-image/set-master-image';
import './profile/xeditable.js';
import './reports/report';
